/*
document.addEventListener("DOMContentLoaded", function () {
    console.log('aa');

    setTimeout(function () {
        console.log('bb');

        var buttons = document.querySelectorAll(".ES-button-CPR");

        console.log('cc');
        console.log(buttons);

        for (var i = 0; i < buttons.length; i++) {
        console.log('zz');
            buttons[i].addEventListener("click", function () {
                console.log('dd');

                var drawer = document.querySelector("cart-drawer");
                if (drawer && drawer.renderContents) {
                    drawer.renderContents();
                }
            });
        }

    }, 3000);
});
*/
document.addEventListener("DOMContentLoaded", function () {

    setTimeout(function () {
    document.addEventListener("click", function (e) {
        var target = e.target.closest(".ES-button-CPR");
        if (!target) return;

        console.log("CLICK CAPTURE Chrome OK");

        var drawer = document.querySelector("cart-drawer");
        if (drawer && drawer.renderContents) drawer.renderContents();
    }, true); // ← IMPORTANT : PHASE DE CAPTURE

    }, 3000);
});